import React from "react";
import {styled, theme, Card, H2, Text, TextFieldWithCopy} from "@reside/ui";
import {Formik} from "formik";
import {SsoConfigurationResponse} from "../../services/SsoService";

const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${theme.space[5]}px;
`;

type Props = Readonly<{
  ssoConfig: SsoConfigurationResponse;
}>;

/**
 * Displays application details with copyable fields.
 */
export const ApplicationDetailsCard = ({ssoConfig}: Props) => {
  return (
    <Card style={{padding: theme.space[7]}}>
      <CardHeader>
        <H2>Application details</H2>
      </CardHeader>
      <Text as="p" fontSize={[3]} marginBottom={theme.space[1]}>
        Copy the details below to configure your application
      </Text>

      {/* Formik required for TextFieldWithCopy integration */}
      <Formik
        initialValues={{
          entityId: ssoConfig.entityId,
          acsUrl: ssoConfig.acsUrl,
        }}
        onSubmit={() => {}}
      >
        <>
          <TextFieldWithCopy label="AUDIENCE (ENTITYID)" name="entityId" />
          <TextFieldWithCopy label="RECIPIENT" name="acsUrl" />
          <TextFieldWithCopy label="ACS (CONSUMER) URL" name="acsUrl" />
        </>
      </Formik>
    </Card>
  );
};
